module.exports = __webpack_public_path__ + "static/Group5996@2x-709d34abe87d5ad909edee59a0b6e314.png";